module.exports = __webpack_public_path__ + "media/images/ig_web-16b3136e8cbffee377cc2800a6b88290.svg";